import GenericPatientDetailsList from "../components/GenericPatientDetailsList";

const PreIntimationPatientsList = () => {
  return (
    <GenericPatientDetailsList
      header="Pre-Intimation"
      screen="pre_intimation"
      iconUrl="/pre_intimation"
    />
  );
};

export default PreIntimationPatientsList;
